<template>
	<div id="app" style="height:100%;">
		<Navbar v-if="isAuthenticated"></Navbar>
		<router-view />
	</div>
</template>
<script>

// @ is an alias to /src
import store from "@/store";
import Navbar from "@/components/Navbar.vue";
export default {
	store,
	name: "App",
	mixins: [],
	components: {
		Navbar
	},
	data: function () {
		return {
		};
	},
	computed: {
		isAuthenticated() {
			return this.$store.getters["auth/isAuthenticated"];
		},
		user() {
			return this.$store.getters["auth/user"];
		}
	},
	mounted: async function () {
		var self = this;
		await self.$store.dispatch("auth/getUser");
	},
	methods: {

	},
};
</script>


